import { TicketSalesCampaignDiscountType } from '@bonsai/shared';

const WHOLE_RE = /^\d+$/;
const DOLLARS_RE = /^(\d+(\.\d{0,2})?|\.\d{1,2})$/;

export function centsToDollarText(cents: number): string {
  return cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
}

export function discountValueToText(
  type: TicketSalesCampaignDiscountType,
  discountValue: number,
): string {
  return type === TicketSalesCampaignDiscountType.FLAT
    ? centsToDollarText(discountValue)
    : String(discountValue);
}

/**
 * The stored value — whole percent, or cents — or null when the text is not a
 * number of that kind. Range rules are the caller's.
 */
export function parseDiscountText(
  type: TicketSalesCampaignDiscountType,
  text: string,
): number | null {
  const trimmed = text.trim();
  if (type === TicketSalesCampaignDiscountType.PERCENT) {
    return WHOLE_RE.test(trimmed) ? Number(trimmed) : null;
  }
  return DOLLARS_RE.test(trimmed) ? Math.round(Number(trimmed) * 100) : null;
}

/** Keeps only what can be typed: digits for a percentage (cents dropped), digits and a point for dollars. */
export function cleanDiscountText(type: TicketSalesCampaignDiscountType, text: string): string {
  return type === TicketSalesCampaignDiscountType.PERCENT
    ? text.split('.')[0].replace(/\D/g, '')
    : text.replace(/[^\d.]/g, '');
}
